export const useMotionPreset = () => {
  const createCard = (delay = 0) => ({
    initial: {
      opacity: 0,
      y: 28
    },
    visibleOnce: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 550,
        delay,
        ease: 'easeOut'
      }
    }
  })

  const title = {
    initial: {
      opacity: 0,
      y: 40,
      scale: 0.98,
      filter: 'blur(14px)'
    },
    visibleOnce: {
      opacity: 1,
      y: 0,
      scale: 1,
      filter: 'blur(0px)',
      transition: {
        duration: 760,
        ease: 'cubic-bezier(0.16, 1, 0.3, 1)'
      }
    }
  }

  const text = {
    initial: {
      opacity: 0,
      y: 44,
      scale: 0.985,
      filter: 'blur(10px)'
    },
    visibleOnce: {
      opacity: 1,
      y: 0,
      scale: 1,
      filter: 'blur(0px)',
      transition: {
        duration: 680,
        delay: 120,
        ease: 'cubic-bezier(0.16, 1, 0.3, 1)'
      }
    }
  }

  const card = createCard()

  return { title, text, card, createCard }
}
